
































import { defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import ContentFeedGrid from "@/components/ContentFeedGrid";
import ContentFeedList from "@/components/ContentFeedList";

export default defineComponent({
  name: "ContentFeedView",
  components: { ContentFeedGrid, ContentFeedList },
  props: {
    contentFeedSearchResult: { type: Object as PropType<ContentFeedSearchResult | null> },
    subscriptionLevels: { type: Array as PropType<SubscriptionLevel[]>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    followedUsersId: { type: Object as PropType<Record<string, boolean>>, default: () => ({}) },
    feedId: { type: String },
    feedListClasses: { type: String },
    enableScroll: { type: Boolean, required: true },
    enablePinPost: { type: Boolean },
    showPinnedOnDiscover: { type: Boolean },
    showFollowButton: { type: Boolean, default: false },
    showReportItem: { type: Boolean, default: true },
    showComment: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    showShare: { type: Boolean, default: true },
    showPrice: { type: Boolean, default: true },
  },
});
